/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Route preset creation request
 */
export interface RoutePresetCreationRequest {
  name: string;
  lpPairIds: Array<number>;
}
